import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { IMAGE_CONFIG, IMAGE_LOADER, ImageConfig, ImageLoaderConfig } from '@angular/common';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { provideClientHydration } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately', // no delay -> required for google lighthouse test
    }),
    provideRouter(routes),
    provideZonelessChangeDetection(),
    provideClientHydration(),
    provideHttpClient(),
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => {
        if (config.width) {
          const before = config.src.split('.').slice(0, -1).join('.');
          const after = config.src.substring(config.src.lastIndexOf('.') + 1, config.src.length);
          return `${before}.${config.width}px.${after}`;
        }
        return `${config.src}`;
      },
    },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        placeholderResolution: 32,
      } as ImageConfig,
    },
  ],
};
